import { css } from 'aphrodite';
import * as React from 'react';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	id?: string;
	label?: string;
	name?: string;
	onChange?(e: React.ChangeEvent<HTMLInputElement>): void;
	required?: boolean;
	value?: string;
}

interface IState {
	warn?: boolean;
}

export class TextInputWithLabel extends React.Component<IProps, IState> {
	public static defaultProps: Partial<IProps> = {
		required: true,
	};

	public render() {
		const { className, name, label, id, value, onChange, required } = this.props;
		const { warn } = this.state;
		return (
			<div className={ `${ css(styleSheet.container) } text-input-with-label ${ className || '' }` }>
				{
					warn && !!required ?
						(
							<label htmlFor={ name || 'text-input' } >
								{ label + ' ' } <span className={ css(styleSheet.required) }>Required Field</span>
							</label>
						)
						:
						(
							<label htmlFor={ name || 'text-input' } >
								{ label || '' }
							</label>
						)
				}
				<br />
				<input
					className={ css(styleSheet.input) }
					type='text'
					id={ id || undefined }
					name={ name || 'text-input' }
					value={ value }
					onChange={ onChange }
					onBlur={ this.onInputBlur }
					onFocus={ this.onInputFocus }
				/>
			</div>
		);
	}

	private onInputBlur = (_: React.FocusEvent<HTMLInputElement>) => {
		if (!this.props.value) {
			this.setState({ warn: true });
		}
	}

	private onInputFocus = () => {
		this.setState({ warn: false });
	}
}
